module.exports = __webpack_public_path__ + "static/media/cleaning.0840f777.png";